import React, { Fragment } from "react";
import { i18n } from "../i18n/i18n";
import "./icons.scss";

type TLinkIconProps = {
  href: string;
  target?: string | undefined;
  title?: string | undefined;
};
type TNotificationIconProps = {
  href: string;
  nNew?: number;
};

export function IconNotifications({ href, nNew }: TNotificationIconProps) {
  const has_new = nNew !== undefined && nNew > 0;
  const className =
    nNew === undefined
      ? "kpm-icon-button notifications kpm-loading"
      : has_new
      ? "kpm-icon-button notifications kpm-has-new-notices"
      : "kpm-icon-button notifications";

  return (
    <a className={className} href={href}>
      <span className="kth-visually-hidden">
        {i18n("Direct notifications")}
      </span>
      {has_new && (
        <span className="kpm-notice-new">
          {nNew}
          <span className="kth-visually-hidden">{i18n("dn-new")}</span>
        </span>
      )}
    </a>
  );
}

export function IconSettings({
  href,
  target = undefined,
  title = undefined,
}: TLinkIconProps) {
  return (
    <a className="icon" href={href} target={target}>
      <svg
        viewBox="0 0 86 86"
        xmlns="http://www.w3.org/2000/svg"
        width="1.2em"
        height="1.2em"
      >
        <title>
          Select how you are notified, how the schedule is displayed, or remove
          subscriptions.
        </title>
        <path
          d="M11.41 72.18a42.98 42.98 0 0 0 20.65 12.41A10.62 10.62 0 0 1 32 83.5a10.5 10.5 0 1 1 20.91 1.35 42.95 42.95 0 0 0 21.3-12.28 10.5 10.5 0 0 1 10.3-18.3 43.05 43.05 0 0 0 0-22.54 10.5 10.5 0 0 1-10.3-18.3A42.94 42.94 0 0 0 52 .94l.01.56a10.5 10.5 0 0 1-21 .2 43 43 0 0 0-19.59 12.12A10.49 10.49 0 0 1 1.38 32.16a43.07 43.07 0 0 0 0 21.68 10.5 10.5 0 0 1 10.04 18.34zM42 57.94a15 15 0 1 0 0-30 15 15 0 0 0 0 30z"
          fill="currentColor"
          fillRule="evenodd"
        ></path>
      </svg>
    </a>
  );
}
